import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { AiCreditTransaction } from './AiCreditTransaction'

/**
 * Same shape as `GetAiCreditTransactionListArgs` — the owner scope rides inside `filter`
 * (`filter.ownerId`), guarded in `AiCreditTransactionListService.scopedFilter`.
 */
@InputType()
export class GetAiCreditTransactionListTotalsArgs extends QueryArgs<AiCreditTransaction> {}
